<template lang="pug">
	.row
		.col-md
			.card
				slide-loader(:display="isLoading")
				.card-header
					span New Industry
				.card-body
					industry-form(:model="industry", ref="form")

				.card-footer.text-right
					router-link(:to="{name: 'industries'}") Cancel
					button.btn.btn-success.ml-2(:disabled="isLoading", @click="save") Save
</template>

<script>
import IndustryForm from './IndustryForm.vue';

export default {
  name: 'IndustryNew',
  components: { IndustryForm },

  data: () => ({
    industry: {
      name: '',
    },
    isLoading: false,
  }),

  mounted() {
    this.$store.dispatch('SET_LOADER_STATE', false);
  },

  methods: {
    async save() {
      const model = await this.$refs.form.validate();

      if (!model) {
        return;
      }

      this.isLoading = true;

      this.$http
        .post('v1/admin/industries', model)
        .then(result => {
          this.isLoading = false;
          this.$toast.success('Complete', 'New industry successful created.');
          this.$router.push({
            name: 'industries',
          });
        })
        .catch(error => {
          this.$toast.error('Industry save error', error.message);
          this.isLoading = false;
        });
    },
  },
};
</script>
